import { render, staticRenderFns } from "./MatchingSubscriptionsTable.vue?vue&type=template&id=f26ed048&scoped=true&"
import script from "./MatchingSubscriptionsTable.vue?vue&type=script&lang=js&"
export * from "./MatchingSubscriptionsTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchingSubscriptionsTable.vue?vue&type=style&index=0&id=f26ed048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26ed048",
  null
  
)

export default component.exports